import React from 'react';
import { FormEvent, useState } from "react";
import { BillingCSVDownloadRequest } from "../gateways/cms/billingData";
import { Entity } from "../gateways/cms/id";
import { SelectOrganization } from "./SelectOrganization";
import { SelectOrganizationModal } from "./SelectOrganizationModal";
import ButtonMUI from "@material-ui/core/Button";
import { ItemSummaryPop } from "./itemSummaryPop";
import { styled } from "@mui/system";
import Color from "../styles/colors.js";

export interface Props {
    onSubmit: (data: BillingCSVDownloadRequest) => unknown;
}

// style
const DataDownloadFormSection = styled("section")`
    margin: 0 0 24px;

    &:nth-of-type(1){
        select{
            min-width: 90px;
        }
    }

    label {
        display: block;
        margin-bottom: 4px;
    }
    select {
        height: 32px;
        padding: 4px 8px;

        & + select{
            margin-left: 16px
        }
    }
    
    button.MuiButton-contained {
        color: #f4f4f4;
        background-color: #3a3e5d;
        border-color: #3a3e5d;
        border-radius: 2px;
    }
`;
const Button = styled(ButtonMUI)`
    height: 32px;
    border-radius: 2px;
`;
const ButtonWhite = styled(Button)`
    background-color: #ffffff;
`;

const DataDownloadFormFooter = styled("footer")`
    display: flex;
    justify-content: space-between;
    align-items: end;
    padding: 16px 24px;
    background-color: ${Color.bgHead};

    position: fixed;
    bottom: 0;
    right: 0;
    width: calc(100vw - 260px);

    button.MuiButton-root{
        color: #f4f4f4;
        background-color: #3a3e5d;
        border-color: #3a3e5d;
        border-radius: 2px;
        &.MuiButton-outlined {
            color: #006699;
            background-color: ${Color.bgHead};
            border: 2px solid #006699;
        }
        &:disabled {
            background-color: #c0c0c0; 
        }
    }

    
`;
const SimpleList = styled("ul")`
    padding-top: 24px;
    display: flex;
    flex-wrap: wrap;
`;
const SimpleListItem = styled("li")`
    position: relative;
    margin-right: 24px;
    margin-bottom: 24px;
    background-color: #F4F4F4;
    border-radius: 2px;
    width: 180px;
                
    select{
        max-width: 11.25em;
        padding: 0 4px 0 8px;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        border: none;
        background-color: transparent;
        pointer-events: none;
    }
    .MuiButton-root{
        position: absolute !important;
        right: 0;
        top: 0;
        min-width: 0;
        padding: 0;
    }
`;

export function BillingCSVDownloadForm({ onSubmit }: Props) {
    const [organizations, setOrganizations] = useState([] as Entity[]);
    const [selectOrganizationModalOpen, setSelectOrganizationModalOpen] = useState(false);
    const [disableClick, setDisableClick] = useState(false); 

    const checkDisable = ():boolean => {
        if(disableClick) return true;
        else if(organizations.length === 0) return true;
        else return false;
    }

    const handleSubmit = (e: FormEvent) => {
        e.preventDefault();
        setDisableClick(true);
        onSubmit({
            organizationIds: organizations.map((o) => o.id),
        });
    };

    const handleDismiss = () => {
        setDisableClick(false);
        setOrganizations([]);
    };
    // DEBUG
    //console.log(organizations);

    return (
        <>
            <form onSubmit={handleSubmit}>
                <DataDownloadFormSection>                    
                    <label htmlFor="organizations">対象のテナント</label>
                    <Button type="button" variant="contained" disableElevation onClick={() => setSelectOrganizationModalOpen(true)}>
                        テナントを選択
                    </Button>

                    <SimpleList>
                        {organizations.map((o) => (
                            <SimpleListItem key={o.id}>
                                <SelectOrganization value={o.id} />
                                <ItemSummaryPop
                                    popTitle={ <SelectOrganization value={o.id} /> }
                                    popMain={ <div>グループ詳細 未取得</div> }
                                    linkDetail={ `/organizations/${o.id}/edit` }
                                />
                            </SimpleListItem>
                        ))}
                    </SimpleList>
                </DataDownloadFormSection>                    

                <DataDownloadFormFooter>
                    <Button type="submit" variant="contained" disabled={checkDisable()} disableElevation>ダウンロード</Button>
                    <ButtonWhite type="button" variant="outlined" onClick={handleDismiss}>やり直し</ButtonWhite>
                </DataDownloadFormFooter>
            </form>

            <SelectOrganizationModal
                open={selectOrganizationModalOpen}
                value={organizations}
                onChange={setOrganizations}
                onClose={() => setSelectOrganizationModalOpen(false)}
            />
        </>
    );
}
